var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-contact-tag-table',{attrs:{"title":_vm.$t('global.models.contact-tag.heading'),"subtitle":_vm.$t('global.models.contact-tag.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }